import styled from "styled-components";
import { Grid } from "@material-ui/core";

export const STGrid = styled(Grid)`
  && {
    padding-top: 8px;
  }
`;
